import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Modal } from 'react-responsive-modal';
import { useDispatch, useSelector } from 'react-redux';
import {
  getHolidayByID,
  getMember,
  getTeams,
  updateHoliday,
} from '../../../redux/MainAction';
import moment from 'moment';

const EditHolidayModal = ({ open, onClose, ID, filters }) => {
  const dispatch = useDispatch();
  const emplo = useSelector((state) => state.Webtracker.member);
  const tmlist = useSelector((state) => state.Webtracker.teams);
  const single = useSelector((state) => state.Webtracker.holidayById);

  const [selectedOption, setSelectedOption] = useState('HOLIDAY');
  const [empDataOption, setEmpDataOption] = useState([]);
  const [empDataValue, setEmpDataValue] = useState([]);
  const [teamDataOption, setTeamDataOption] = useState([]);
  const [teamDataValue, setTeamDataValue] = useState([]);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    if (ID) getLis();
  }, [ID]);

  const getLis = () => {
    var id = {
      id: ID,
    };
    dispatch(getHolidayByID(id));
  };

  useEffect(() => {
    if (!tmlist || !Array.isArray(tmlist?.rows)) {
      var data2 = {
        offset: 0,
        limit: 10,
      };
      dispatch(getTeams(data2));
    }
  }, [tmlist]);

  useEffect(() => {
    if (!emplo || !Array.isArray(emplo?.rows)) {
      var data2 = {
        offset: 0,
        limit: 10,
      };
      dispatch(getMember(data2));
    }
  }, [emplo]);

  useEffect(() => {
    if (emplo && emplo?.rows) {
      const option = emplo?.rows?.map((user) => {
        return {
          label: `${user?.firstName} ${user?.lastName}`,
          value: user?.id,
        };
      });
      setEmpDataOption(option);
    }
    if (tmlist && tmlist?.rows) {
      const option = tmlist?.rows?.map((user) => {
        return {
          label: `${user?.name}`,
          value: user?.id,
        };
      });
      setTeamDataOption(option);
    }
  }, [emplo, tmlist]);

  const [addData, setAddData] = useState({
    name: '',
    startDate: '',
    endDate: '',
    applicableTo: 'WORKSPACE-WIDE',
    // "isNonWorkingDay": true,
    message: '',
  });

  const onEmployeeChange = (value) => {
    if (value) {
      setEmpDataValue(value);
    }
  };
  const onTeamChange = (value) => {
    if (value) {
      setTeamDataValue(value);
    }
  };

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const onHandleAddData = (e) => {
    const { name, value } = e.target;
    setAddData({ ...addData, [name]: value });
  };

  useEffect(() => {
    if (single) {
      setAddData({
        name: single?.name,
        startDate: moment(single?.startDate).format('YYYY-MM-DD'),
        endDate: moment(single?.endDate).format('YYYY-MM-DD'),
        applicableTo: single?.applicableTo,
        // "isNonWorkingDay": ,
        message: single?.message,
      });
      setIsChecked(single?.isNonWorkingDay);
    }
  }, [single]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (addData?.applicableTo === 'CUSTOM') {
      if (empDataValue.length === 0) {
        toast.error('Please Add employees  !', {
          position: 'top-right',
        });
        return false;
      }
      const emp = empDataValue?.map((itm) => itm.value);
      const payload = {
        id: ID,
        type: selectedOption,
        name: addData?.name,
        startDate: moment(addData?.startDate).format('YYYY-MM-DD'),
        endDate: moment(addData?.endDate).format('YYYY-MM-DD'),
        applicableTo: addData?.applicableTo,
        isNonWorkingDay: isChecked,
        message: addData?.message,
        employeeIds: emp,
      };
      dispatch(updateHoliday(payload));
      onClose();
    } else if (addData.applicableTo === '') {
      if (teamDataValue.length === 0) {
        toast.error('Please Add team  !', {
          position: 'top-right',
        });
        return false;
      }
      const emp = teamDataValue?.map((itm) => itm.value);
      const payload = {
        id: ID,
        type: selectedOption,
        name: addData?.name,
        startDate: moment(addData?.startDate).format('YYYY-MM-DD'),
        endDate: moment(addData?.endDate).format('YYYY-MM-DD'),
        applicableTo: addData?.applicableTo,
        isNonWorkingDay: isChecked,
        message: addData?.message,
        teamIds: emp,
      };
      dispatch(updateHoliday(payload));
      onClose();
    } else {
      const payload = {
        id: ID,
        type: selectedOption,
        name: addData?.name,
        startDate: moment(addData?.startDate).format('YYYY-MM-DD'),
        endDate: moment(addData?.endDate).format('YYYY-MM-DD'),
        applicableTo: addData?.applicableTo,
        isNonWorkingDay: isChecked,
        message: addData?.message,
      };
      dispatch(updateHoliday(payload, filters));
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal1 leave_modal' }}
    >
      <div className="d-flex justify-content-between align-items-center pb-2">
        <h6>Update Holiday</h6>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>
      <div className="tab-content pr-2">
        <div className=" d-flex   align-items-center">
          <label className=" d-flex align-items-center">
            <input
              type="radio"
              name="day"
              value="HOLIDAY"
              className="mr-2 text-muted"
              checked={selectedOption === 'HOLIDAY'}
              onChange={handleChange}
            />
            Holiday
          </label>

          <label className="ml-3 d-flex align-items-center">
            <input
              type="radio"
              name="day"
              value="MEMORIAL-DAY"
              className="mr-2 text-muted"
              checked={selectedOption === 'MEMORIAL-DAY'}
              onChange={handleChange}
            />
            Memorial Day
          </label>
        </div>
        <input
          type="text"
          name="name"
          className="form-control"
          id="name"
          placeholder="Enter name"
          value={addData?.name}
          onChange={onHandleAddData}
        />
        <div className="form-group mt-1">
          <label htmlFor="username1" className="font-14 text-muted ">
            Start Date
          </label>
          <input
            type="date"
            className="form-control"
            id="username1"
            name="startDate"
            value={addData?.startDate}
            onChange={onHandleAddData}
          />
        </div>
        <div className="form-group">
          <label htmlFor="username2" className="font-14 text-muted ">
            End Date
          </label>
          <input
            type="date"
            className="form-control "
            id="username2"
            name="endDate"
            value={addData?.endDate}
            onChange={onHandleAddData}
          />
        </div>
        <select
          className="form-control"
          name="applicableTo"
          value={addData?.applicableTo}
          onChange={onHandleAddData}
        >
          <option value="TEAM-WIDE">Team-wide</option>
          <option value="CUSTOM">Custom</option>
          <option value="WORKSPACE-WIDE">Workspace wide</option>
        </select>

        {addData?.applicableTo === 'CUSTOM' && (
          <div className="mt-2">
            <Select
              value={empDataValue}
              onChange={onEmployeeChange}
              options={empDataOption}
              isMulti={true}
            />
          </div>
        )}
        {addData?.applicableTo === 'TEAM-WIDE' && (
          <div className="mt-2">
            <Select
              value={teamDataValue}
              onChange={onTeamChange}
              options={teamDataOption}
              isMulti={true}
            />
          </div>
        )}

        <label className="d-flex align-items-center text-muted mt-3">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
            className="mr-2 custom-checkbox"
          />
          Non-Working Day
        </label>

        {/* <select className="form-control">
            <option >Select channel</option>
            <option value="true">Channel 1</option>
            <option value="false">Channel 2</option>
        </select> */}

        <textarea
          type="text"
          className="form-control mt-2"
          rows={3}
          placeholder="Message"
          name="message"
          value={addData?.message}
          onChange={onHandleAddData}
        />
      </div>

      <div className="modal-footer d-flex justify-content-center align-items-center">
        {/* <button type="button" className="btn btn-light" onClick={onClose} >Cancel</button> */}
        <button type="button" className="btn btn-dark" onClick={onSubmit}>
          Submit
        </button>
      </div>
    </Modal>
  );
};

export default EditHolidayModal;
